module.exports = __webpack_public_path__ + "static/media/codemasters_logo_notext.a40aa478.svg";